import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4a12.25 12.25 0 0 0 0 16","key":"svg-0"}],["path",{"d":"M17 4a12.25 12.25 0 0 1 0 16","key":"svg-1"}]]

/**
 * IconParentheses
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGFyZW50aGVzZXMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgNGExMi4yNSAxMi4yNSAwIDAgMCAwIDE2IiAvPgogIDxwYXRoIGQ9Ik0xNyA0YTEyLjI1IDEyLjI1IDAgMCAxIDAgMTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/parentheses
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconParentheses = createReactComponent('outline', 'parentheses', 'Parentheses', __iconNode);

export default IconParentheses;